import React, { useEffect } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import Hero from "components/hero/Hero";
import Footer from "components/footers/FiveColumnDark";
import CompanyLocation from "components/features/CompanyLocation";
import GroupCompany from "components/cards/GroupCompany";
import ContactUsHeader from "components/hero/ContactUsHeader";
import GlobalStyle from "helpers/GlobalStyle";
import SplashAnimationContainer from "helpers/SplashAnimationContainer";
import useScreenSize from "helpers/useScreenSize";

const BgWrapper = styled.div`
  ${tw`fancy-feature-mask`}
`;
export default () => {
  const sectionId = window.location.hash;
  const { isXs } = useScreenSize();

  useEffect(() => {
    // Scroll to the specific section after the component mounts
    const section = document.getElementById(sectionId.substring(1));
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  }, [sectionId]);

  return (
    <div style={{ marginTop: "50px" }}>
      <GlobalStyle />
      <Hero isXs={isXs} />
      <SplashAnimationContainer>
        <div>
          {" "}
          {/* Contact us header text */}
          <ContactUsHeader isXs={isXs} />
        </div>
        {isXs ? (
          <CompanyLocation isXs={isXs} />
        ) : (
          <BgWrapper>
            <CompanyLocation isXs={isXs} />
          </BgWrapper>
        )}
        <div className={!isXs ? "gradient-container" : ""}>
          <GroupCompany isXs={isXs} />
        </div>
        <Footer isXs={isXs} />
      </SplashAnimationContainer>
    </div>
  );
};
